import Grid from '@mui/material/Unstable_Grid2'
import { Slider } from '../../../models/sliders'
import BrandAutocomplete from '@/contexts/shared/components/inputs/BrandAutocomplete'
import { CustomTextField, LineAutocomplete } from '@/contexts/shared/components/inputs'

type SliderModalHeaderProps = {
  sliderState: Slider
  handleInputChange: (inputName: string, value: any) => void
}

const SliderModalHeader = ({ sliderState, handleInputChange }: SliderModalHeaderProps) => {
  return (
    <Grid container spacing={2} justifyContent="space-between" alignItems="flex-start">
      <Grid xs={12} md={sliderState.brand != null ? 6 : 8}>
        <CustomTextField label="title" inputName="title" required value={sliderState.title} handleInputChange={handleInputChange} />
      </Grid>
      <Grid xs={12} sm={sliderState.brand != null ? 6 : 12} md={sliderState.brand != null ? 3 : 4}>
        <BrandAutocomplete value={sliderState.brand} handleInputChange={handleInputChange} />
      </Grid>
      {sliderState.brand != null && (
        <Grid xs={12} sm={6} md={3}>
          <LineAutocomplete value={sliderState.line} brand={sliderState.brand} handleInputChange={handleInputChange} />
        </Grid>
      )}
    </Grid>
  )
}

export default SliderModalHeader
